import { useEffect, useMemo, useState } from 'react';

/**
 * Used by `AvatarImage` (`~/shared/components/AvatarImage`): when the URL is missing or
 * the image fails (e.g. 404), `src` becomes undefined so initials fallback children render.
 */
export function useOptionalAvatarImage(avatarUrl: string | null | undefined): {
  src: string | undefined;
  imgProps: { onError: () => void };
} {
  const normalized = avatarUrl?.trim() || undefined;
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [normalized]);

  const src = normalized && !imageFailed ? normalized : undefined;

  const imgProps = useMemo(
    () => ({
      onError: () => {
        setImageFailed(true);
      },
    }),
    [],
  );

  return { src, imgProps };
}
